import { useState } from "react"



export const UseLoading = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const startLoading = () => setIsLoading(true);
    const stopLoading = () => setIsLoading(false);
    const invertStatusLoading = () => setIsLoading(val => !val);

    return {
        startLoading,
        stopLoading,
        invertStatusLoading,
        isLoading
    }
}